import './action-widget.scss';
import { Button } from '../../components/form/button';
import { QuipliLink } from '../../components/link/quipli-link';
import classNames from 'classnames';
import Icon from '../../components/icons/icon';
import { Dropdown } from '../../components/dropdown/dropdown';
import { Typography } from '../../components/typography/typography';
import { TenantContext } from '../../context/tenant-context';
import { useContext } from 'react';
import { useResponsive } from '../../hooks/use-reponsive';

export const ActionWidget = ({ className = '' }) => {
  const { isMobileOrTablet } = useResponsive();
  const { spaMode } = useContext(TenantContext);

  const quickAccess = [
    {
      url: 'orders/create',
      title: 'New Order',
      desc: 'Track your products or services',
      icon: <Icon icon="ShoppingBag" />,
    },
    {
      url: 'orders/create_quote',
      title: 'New Quote',
      desc: 'Create quick pricing estimates',
      icon: <Icon icon="AddDocument" />,
    },
    {
      url: 'users/import',
      title: 'New Customer',
      desc: 'Manage customer information',
      icon: <Icon icon="AddCustomer" />,
    },
    {
      url: 'products',
      title: 'New Inventory',
      desc: 'Track quantity, and status',
      icon: <Icon icon="Inventory" />,
    },
  ];

  return (
    <div className="action-widget">
      <Dropdown
        trigger={(isMenuOpen) => (
          <Button className={classNames('widget-btn', { legacy: !spaMode }, className)}>
            <Icon icon={'Plus'} stroke={!spaMode || isMobileOrTablet ? 'white' : ''} />
            {isMenuOpen ? (
              <Icon icon={'ChevronUp'} size="small" stroke={!spaMode || isMobileOrTablet ? 'white' : ''} />
            ) : (
              <Icon icon={'ChevronDown'} size="small" stroke={!spaMode || isMobileOrTablet ? 'white' : ''} />
            )}
          </Button>
        )}
      >
        {quickAccess.map((op, index) => (
          <QuipliLink key={index} className="quick-action" to={op.url}>
            {op.icon}
            <div className="action-info">
              <Typography type="text-sm" weight="medium">
                {op.title}
              </Typography>
              <Typography type="text-xs">{op.desc}</Typography>
            </div>
          </QuipliLink>
        ))}
      </Dropdown>
    </div>
  );
};
